import { BuyerCommentThreadOverview } from '@/types';
import { removeIrrelevantThreads } from '@/utils/comment-workaround';

export const setBuyerCommentThreads = (data: BuyerCommentThreadOverview[]) => {
    const filteredThreads = removeIrrelevantThreads(data);

    return {
        type: 'BUYER_SET_COMMENT_THREADS',
        data: filteredThreads,
    };
};
